module.exports = __webpack_public_path__ + "img/wrench.d7e04288.svg";